import {
  EmployeeProfileStatus,
  OrganizationUserQuery,
} from "@common/utils/graphql";
import { ExtractTypename } from "@common/utils/graphql/utils";

type OrganizationUser = ExtractTypename<
  OrganizationUserQuery["organizationUser"],
  "QueryOrganizationUserSuccess"
>["data"];

export const getRoleOrEmployeeStatus = (user?: OrganizationUser) => {
  return user?.employee?.status === EmployeeProfileStatus.Terminated
    ? user.employee.displayStatus
    : user?.employeeDisplayRole;
};
